module.exports = __webpack_public_path__ + "img/US_ResourceWood_ua.178999be.webp";